import { Link } from 'react-router-dom';
import { BarChart, Users, Briefcase, LockKeyhole } from 'lucide-react';
import { Button } from '../../components/ui/Button';

export default function DataSharingBenefitsPage() {
  return (
    <div className="container mx-auto p-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-4">
            Pourquoi partager vos données est-il bénéfique ?
          </h1>
          
          <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-6 mb-6">
            <h2 className="text-xl font-medium text-blue-900 dark:text-blue-100 mb-3">
              🔒 Votre tranquillité d'esprit avant tout
            </h2>
            <p className="mt-2 text-blue-800 dark:text-blue-200">
              Vos données ne seront jamais utilisées à des fins qui vont à l'encontre des intérêts de votre entreprise. Elles sont protégées, anonymisées lors des analyses globales, et vous gardez le contrôle total sur ce que vous partagez.
            </p>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-6">
            Avantages du partage de données
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-8">
            <div className="bg-card p-6 rounded-lg border border-border shadow-sm">
              <div className="flex items-center mb-4">
                <BarChart className="h-6 w-6 text-primary mr-3" />
                <h3 className="text-lg font-medium text-card-foreground">Meilleur accès au financement</h3>
              </div>
              <p className="text-muted-foreground">
                En partageant vos données de transactions, nous pouvons évaluer plus précisément la santé financière de votre entreprise, ce qui facilite l'accès aux crédits, leasing d'équipements et autres solutions financières.
              </p>
            </div>

            <div className="bg-card p-6 rounded-lg border border-border shadow-sm">
              <div className="flex items-center mb-4">
                <Users className="h-6 w-6 text-primary mr-3" />
                <h3 className="text-lg font-medium text-card-foreground">Analyse personnalisée</h3>
              </div>
              <p className="text-muted-foreground">
                Nos analystes peuvent vous fournir des conseils spécifiques à votre situation, identifier des opportunités d'optimisation et vous recommander des stratégies adaptées à votre secteur et à votre stade de développement.
              </p>
            </div>

            <div className="bg-card p-6 rounded-lg border border-border shadow-sm">
              <div className="flex items-center mb-4">
                <Briefcase className="h-6 w-6 text-primary mr-3" />
                <h3 className="text-lg font-medium text-card-foreground">Conseils financiers avancés</h3>
              </div>
              <p className="text-muted-foreground">
                Notre assistant Adha utilise des modèles d'intelligence artificielle pour vous offrir des conseils financiers, fiscaux, juridiques et en R&D adaptés à votre entreprise, basés sur l'analyse de données réelles.
              </p>
            </div>

            <div className="bg-card p-6 rounded-lg border border-border shadow-sm">
              <div className="flex items-center mb-4">
                <LockKeyhole className="h-6 w-6 text-primary mr-3" />
                <h3 className="text-lg font-medium text-card-foreground">Sécurité et contrôle</h3>
              </div>
              <p className="text-muted-foreground">
                Vous gardez le contrôle total sur les données que vous partagez et avec qui. Vous pouvez révoquer les accès à tout moment et toutes les données sont traitées selon les normes de sécurité les plus strictes.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-10 mb-6">
            Comment nous utilisons vos données
          </h2>

          <p className="text-muted-foreground">
            Nous utilisons des algorithmes de machine learning pour évaluer la cote de crédit de votre entreprise à travers ses transactions, au lieu de tout baser sur les états financiers traditionnels. Cette approche permet:
          </p>

          <ul className="list-disc pl-5 mt-4 space-y-2 text-muted-foreground">
            <li>Une évaluation plus juste et complète de votre activité</li>
            <li>La prise en compte des tendances et de la régularité des transactions</li>
            <li>Une analyse prédictive de votre capacité de remboursement</li>
            <li>L'identification de solutions de financement adaptées à votre profil</li>
          </ul>

          <p className="mt-6 text-muted-foreground">
            Vos données contribuent également à l'entraînement de nos modèles d'intelligence artificielle, ce qui améliore la qualité des conseils fournis par notre assistant Adha et bénéficie à l'ensemble de la communauté des entrepreneurs.
          </p>

          <div className="mt-10 pt-6 border-t border-border">
            <h3 className="text-xl font-semibold text-foreground mb-4">
              Retourner aux paramètres
            </h3>
            <Button asChild>
              <Link to="../..">
                Configurer mes paramètres de partage
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
